import { useState } from 'react';
import RecepcionesList from './List.jsx';
import RecepcionForm from './Form.jsx';
import RecepcionDetail from './Detail.jsx';

export default function RecepcionesPage() {
  const [view, setView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = () => setRefreshKey((key) => key + 1);

  if (view === 'create') {
    return <RecepcionForm onCancel={() => setView('list')} onSaved={() => { refresh(); setView('list'); }} />;
  }

  if (view === 'detail' && selectedId) {
    return <RecepcionDetail ingresoId={selectedId} onBack={() => { setView('list'); refresh(); }} />;
  }

  return (
    <RecepcionesList
      refreshKey={refreshKey}
      onCreate={() => {
        setSelectedId(null);
        setView('create');
      }}
      onSelect={(id) => {
        setSelectedId(id);
        setView('detail');
      }}
    />
  );
}
